import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';

// Import Components
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import AboutService from './components/AboutService';
import GallerySection from './components/GallerySection';
import TestimonialsSection from './components/TestimonialsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

// Global Styles
const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
  }

  /* Custom Scrollbar */
  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-track {
    background: #1f2937;
  }

  ::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #9333ea 0%, #ec4899 100%);
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(135deg, #7e22ce 0%, #db2777 100%);
  }
`;

// Main App Container
const AppContainer = styled.div`
  min-height: 100vh;
  background: white;
  position: relative;
`;

// Main Content Wrapper
const MainContent = styled.main`
  width: 100%;
`;

// App Component
function App() {
  return (
    <>
      <GlobalStyle />
      <AppContainer>
        {/* Header - Fixed Navigation */}
        <Header />

        {/* Main Content */}
        <MainContent>
          {/* Hero Section */}
          <HeroSection />

          {/* Services Section */}
          {/* <ServicesSection /> */}

          <AboutService />

          {/* Gallery Section */}
          <GallerySection />

          {/* Testimonials Section */}
          <TestimonialsSection />

          {/* Contact Section */}
          <ContactSection />
        </MainContent>

        {/* Footer */}
        <Footer />
      </AppContainer>
    </>
  );
}

export default App;